import type {
  ProductListGroup,
  Product as ProductType,
} from "constants/modelCompareData/types";

/**
 * Gathers list of product groups from provided list
 */
const getAllProductGroups = (products: ProductType[]) =>
  products.map(
    (product) => (product.productListGroup as ProductListGroup) ?? null,
  );

export const groupProducts = (products: ProductType[]) => {
  const result: {
    productListGroup: ProductListGroup | null;
    span: number;
  }[] = [];

  let current: (typeof result)[number] = {
    productListGroup: null,
    span: 0,
  };

  // sets the amount of columns a product group should span
  for (const productListGroup of getAllProductGroups(products)) {
    const productListGroupId = productListGroup?.id ?? null;
    if (productListGroupId === (current.productListGroup?.id ?? null)) {
      current.span++;
      continue;
    }
    result.push(current);
    current = { productListGroup, span: 1 };
  }
  if (current.span) {
    result.push(current);
  }

  return result.filter((x) => !!x.span);
};
